import React, { useEffect, useState, useRef } from 'react';
import { FixedSizeGrid as Grid } from 'react-window';
import dayjs from 'dayjs';
import { Modal, Button, Form, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import firebase from '../../../firebase';
import { toast } from 'react-toastify';
import isBetween from 'dayjs/plugin/isBetween';
import config from '../../../config';
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';
import logodirect from 'assets/img/logoIcon.png';
import tripadvisor from 'assets/img/logos/tripadvisor.jpg';
import locasun from 'assets/img/logos/locasun.png';
import homeToGo from 'assets/img/logos/homeToGo.jpeg';
import kayak from 'assets/img/logos/kayak.webp';
import homerez from 'assets/img/logos/homerez.png';
import booking from 'assets/img/logos/booking.png';

import './calendar.css'
dayjs.extend(isBetween);

const openLinkInNewTab = (url) => {
  const newTab = window.open(url, '_blank');
  if (newTab) {
    newTab.focus(); // Focalise le nouvel onglet
  } else {
    alert('Le pop-up a été bloqué.'); // Cas où le pop-up est bloqué
  }
};
const toolsColors = {
  booking: 'booking',
  airbnb: 'airbnb',
  direct: 'direct',
  website: 'site internet',
};

const toolLogos = {
  booking,
  airbnb: logoAirbnb,
  direct: logodirect,
  expedia: logoexpedia,
  abritel: logoabritel,
  tripadvisor,
  locasun,
  homeToGo,
  kayak,
  homerez,
  siteinternet: logodirect,
  partenaire: null,
  partner: null,
};


const generateCalendarDates = (startDate, days) => {
  return Array.from({ length: days }, (_, i) => {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    return date;
  });
};

const formatDateT = (date) => {
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1).padStart(2, '0');
  const day = String(date?.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const Calendar = () => {

  const [dates, setDate] = useState([]);
  const [showUnavailableModal, setShowUnavailableModal] = useState(false);
  const [unavailableDetails, setUnavailableDetails] = useState({
    villaId: null,
    startDate: null,
    endDate: null,
    message: '',
  });
  const [showModal, setShowModal] = useState(false);
  const [reservationDetails, setReservationDetails] = useState(null);
  const [reservations, setReservations] = useState([]);
  const [villas, setVilla] = useState([]);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const gridHeight = window.innerHeight * 0.65;
  const rowHeight = 40;
  const columnWidth = 160;
  const columnWidthVilla = 260;
  const tableRef = useRef(null);
  const [viewMode, setViewMode] = useState('week');

  const headerRef = useRef(null);
  const villaRef = useRef(null);

  const handleCellClick = (reservation) => {
    setReservationDetails(reservation);
    setShowModal(true);
  };

  const filteredVillas = villas?.filter((villa) => {
    const nameMatches = villa.name?.toLowerCase().includes(searchQuery.toLowerCase());
    const typeMatches = selectedType !== '' ? villa?.type === selectedType : true;
    return nameMatches && typeMatches;
  });

  const loadVilla = () => {
    firebase.firestore().collection('properties')
      .orderBy('nameHouse', "asc")
      .get().then((snap) => {
        let s = [];
        snap.forEach((d) => {
          var l = d.data();
          if (!l?.delete) {
            s.push({ type: l.type?.value || null, id: d.id, name: l.nameHouse, picture: l.gallery?.length > 0 ? l.gallery[0] : null });
          }
        });
        setVilla(s);
      }).catch((error) => {
        var errorMessage = error.message;
        toast.error(errorMessage);
      });
  };

  const getMinMaxStartDate = (reservations) => {
    let minDate = new Date();
    let maxDate = new Date(0);

    reservations.forEach((reservation) => {
      const startDate = new Date(reservation.startDate);
      if (startDate < minDate) {
        minDate = startDate;
      }
      if (startDate > maxDate) {
        maxDate = startDate;
      }
    });

    return { minDate, maxDate };
  };

  const loadBooking = () => {
    loadVilla()
    firebase.firestore().collection('bookings').get().then((snap) => {

      let transformedBookings = [];
      snap.forEach((d) => {
        const bookingData = d.data();
        bookingData.id = d.id;
        if (!bookingData?.delete && bookingData.statut?.value === 'confirmed') {
          transformedBookings.push(bookingData);
        }
      });

      const bookings = transformBookingData(transformedBookings);

      setReservations(bookings);
      const { minDate, maxDate } = getMinMaxStartDate(bookings);
      const timeDifference = maxDate - minDate;
      const numberOfDays = Math.ceil(timeDifference / (1000 * 3600 * 24));

      if (numberOfDays > 0) {
        setDate(generateCalendarDates(minDate, numberOfDays));
      } else {
        setDate(generateCalendarDates(minDate, 31));
      }
    })
  };


  useEffect(() => {
    firebase.firestore().collection('dates').doc('unavailable').get().then((doc) => {
      if (doc) {
        let d = doc.data();
        if (d.dates) { 
          setUnavailableDates(d.dates);
        }
      }
    });
  }, []);

  const getSaturdayOfWeek = (date) => {
    const day = date.getDay();
    const diff = (day < 6 ? -day : 6 - day);
    const saturday = new Date(date);
    saturday.setDate(date.getDate() + diff);
    saturday.setHours(0, 0, 0, 0);
    return saturday;
  };


  useEffect(() => {
    setTimeout(() => {
      scrollToToday()
    }, 300)
  }, [dates])
  const transformBookingData = (bookings) => {
    return bookings.map((booking) => {
      const originLogo = booking?.origin?.value ? toolLogos[booking?.origin?.value] : null;
    
      return {
        ...booking,
        villaId: booking.property.value,
        villaName: booking.property.label,
        companyLogo: originLogo,
        company: booking?.origin?.value,
        tool: booking?.origin?.label,
        startDate: dayjs(booking.checkin?.seconds * 1000).format('YYYY-MM-DD'), // Transforme les dates en format ISO
        endDate: dayjs(booking.checkout?.seconds * 1000).format('YYYY-MM-DD'),
        clientName: `${booking.guest.firstName} ${booking.guest.lastName}`,
        clientId: booking.client.value,
        price: parseFloat(booking?.total_pay?.replace(',', '.')),
      };
    });
  };
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    let dateS = new Date(newDate)
    const todayIndex = dates.findIndex((date) =>
      dayjs(date).isSame(dayjs(dateS), 'day')
    );

    if (todayIndex !== -1) {
      scrollToColumn(todayIndex);
    }
  };
  const isSelectedDate = (date) => {
    const today = new Date(selectedDate);

    return (
      date?.getDate() === today?.getDate() &&
      date?.getMonth() === today?.getMonth() &&
      date?.getFullYear() === today?.getFullYear()
    );
  };

  useEffect(() => {
    loadBooking()
  }, [])
  const isDateInReservation = (dates, reservationStartDate) => {
    const formattedReservationDate = formatDateT(new Date(reservationStartDate));
    return dates.some(date => formatDateT(date) === formattedReservationDate);
  };
  const groupReservationsByWeek = (reservations) => {
    const weeks = {};

    reservations.forEach(reservation => {
      const startDate = new Date(reservation.startDate);
      const weekStart = getSaturdayOfWeek(startDate);
      const weekKey = formatDateT(weekStart);

      if (!weeks[weekKey]) {
        weeks[weekKey] = [];
      }
      weeks[weekKey].push(reservation);
    });

    return weeks;
  };


  const scrollToColumn = (columnIndex) => {
    if (tableRef.current) {
      tableRef.current.scrollToItem({
        columnIndex,
        rowIndex: 0, // Si vous souhaitez rester sur la première ligne
      });
    }
  };

  const scrollToToday = () => {
    const todayIndex = dates.findIndex((date) =>
      dayjs(date).isSame(dayjs(), 'day')
    );

    if (todayIndex !== -1) {
      scrollToColumn(todayIndex + 2);
    }
  };


  const handleCellToggleAvailability = (villaId, date) => {
    const existingUnavailable = unavailableDates.find(
      (unav) => unav.villaId === villaId && date >= unav.startDate && date <= unav.endDate
    );

    if (existingUnavailable) {
      // message de confirmation de suppression
      if (confirm('Supprimer l\'disponibilité ?')) {
        const updatedUnavailableDates = unavailableDates.filter(
          (unav) => !(unav.villaId === villaId && date >= unav.startDate && date <= unav.endDate)
        );
        firebase.firestore().collection("dates").doc("unavailable").set({ dates: updatedUnavailableDates });
        setUnavailableDates(updatedUnavailableDates);
      }

    } else {
      handleCellUnavailableClick(villaId, date)
    }
  };
  const itemKey = ({ columnIndex, data, rowIndex }) => {
    // Trouver l'élément correspondant aux indices donnés 

    // Retourner une clé unique pour chaque élément.
    // Ici, l'ID de l'élément et l'indice de la colonne sont combinés.
    return `${columnIndex}-${rowIndex}`;
  };

  const getPlacement = (dates, reservationStartDate) => {
    const formattedReservationDate = formatDateT(new Date(reservationStartDate));
    const index = dates.findIndex(date => formatDateT(date) === formattedReservationDate);
    return (index !== -1 ? index : 0) * 10;
  };
  function calculatePixelsBetweenDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const differenceInMilliseconds = end - start;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const pixelsPerDay = columnWidth / 7;
    const totalPixels = differenceInDays * pixelsPerDay;

    return {
      days: differenceInDays,
      pixels: totalPixels === 0 ? 20 : totalPixels,
    };
  }



  const handleCellUnavailableClick = (villaId, date) => {
    setUnavailableDetails({
      ...unavailableDetails,
      startDate: date,
      endDate: dayjs(date).format('YYYY-MM-DD'),
      villaId,
    });
    setShowUnavailableModal(true);
  };


  const CellWeek = ({ columnIndex, rowIndex, style }) => { 
    const cellStyle = {
      ...style,
      position: 'absolute',
      lineHeight: '40px',
      border: '1px solid #ddd',
    };

    if (rowIndex === 0 && columnIndex === 0) {
      return (
        <div
          style={{
            ...cellStyle,
            backgroundColor: '#f0f0f0',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: '40px',
          }}
        >
          Villas
        </div>
      );
    }
    const weeks = getVisibleDates()
    if (rowIndex === 0) {
      return (
        <div
          id={dayjs(dates[columnIndex - 1]).format('DD/MM/YYYY')}
          style={{
            ...cellStyle,
            backgroundColor: dayjs(dates[columnIndex - 1]).isSame(dayjs(), 'day') ? '#003366' : isSelectedDate(dates[columnIndex - 1]) ? "#c7454560" : '#f0f0f0',
            color: dayjs(dates[columnIndex - 1]).isSame(dayjs(), 'day') || isSelectedDate(dates[columnIndex - 1]) ? '#ffffff' : '#5e6e82',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: '40px',
            border: 'none'
          }}
        >
          sem. {formatDate(weeks[columnIndex][0])}
        </div>
      );
    }

    if (columnIndex === 0 && rowIndex > 0) {
      return (
        <div

          key={`${filteredVillas[rowIndex - 1].id}`}
          style={{
            ...cellStyle,
            backgroundColor: '#f7f7f7',
            fontWeight: 'bold',
            lineHeight: '40px',
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        > <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
            <a
              href={`/villa/edit/${filteredVillas[rowIndex - 1].id}`}
              target="_blank"
              style={{
                textDecoration: "none",
                cursor: "pointer",
                color: "inherit",
              }}
            >
              {filteredVillas[rowIndex - 1]?.picture ? (

                <img
                  src={filteredVillas[rowIndex - 1]?.picture}
                  alt={filteredVillas[rowIndex - 1]?.name}
                  className="w-5 h-5 mr-2"
                  style={{ marginRight: 10, width: 150, draggable: 'none' }}
                />
              ) : <p>Aucune image</p>}
            </a>
          </Tooltip>
        }
      ><a
          href={`/villa/edit/${filteredVillas[rowIndex - 1].id}`}
          target="_blank"
          style={{
            textDecoration: "none",
            cursor: "pointer",
            color: "inherit",
            paddingLeft:20
          }}
        >
            {/* {filteredVillas[rowIndex - 1]?.picture && (

              <img
                src={filteredVillas[rowIndex - 1]?.picture}
                alt={filteredVillas[rowIndex - 1]?.name}
                className="w-5 h-5 mr-2"
                style={{ marginRight: 10, width: 47, draggable: 'none' }}
              />
            )} */}
            {filteredVillas[rowIndex - 1]?.name || ''}
          </a>
          </OverlayTrigger>
        </div>
      );
    }

    function calculateMarginLeft(datesArray, startDate) {
      const start = new Date(startDate);
      const position = datesArray.findIndex(date => date.toDateString() === start.toDateString());
      if (position === -1) {
        throw new Error('La date de début ne figure pas dans le tableau des dates.');
      }
      const pixelsPerDay = columnWidth / 7;
      const marginLeft = position * pixelsPerDay;

      return marginLeft;
    }


    const villa = filteredVillas[rowIndex - 1];
    const week = weeks[columnIndex]
    const weekStart = week[0];

    const dateString = formatDateT(weekStart);
    const weekKey = formatDateT(getSaturdayOfWeek(new Date(weekStart)));
    const groupedReservations = groupReservationsByWeek(reservations);

    const weekReservations = groupedReservations[weekKey] || [];
    let reservation = weekReservations.find(
      (r) => r.villaId === villa.id && isDateInReservation(week, r.startDate)
    );
    if (reservation) {
      const result = calculatePixelsBetweenDates(reservation.startDate, reservation.endDate)
      return (
        <div key={reservation.id}
          style={{
            ...cellStyle,
            // position: 'relative',
            zIndex: 1,
            whiteSpace: 'nowrap',
            fontSize: '12px',
            color: '#007bff',
            textAlign: 'center',
            cursor: 'pointer',
            padding: '1px',

          }}
          onClick={() => handleCellClick(reservation)} // Ouvrir la modal au clic
        >
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip style={{ position: 'fixed' }} id="nextTooltip">

                <>
                  <p>{reservation.companyLogo && <img src={reservation.companyLogo} alt="Logo" style={{ width: '20px' }} />} Réservé via: {reservation.tool}</p>
                  <p><strong>Client:</strong> {reservation.clientName}</p>
                  <p>
                    <strong>Villa:</strong> {reservation?.villaName}
                  </p>
                  <p><strong>Dates:</strong> {dayjs(reservation.startDate).format('DD/MM/YYYY')} - {dayjs(reservation.endDate).format('DD/MM/YYYY')}</p>

                  <p><strong>Prix payé:</strong> {new Intl.NumberFormat('fr-FR').format(reservation?.total_pay)} €</p>

                </>
              </Tooltip>
            }>
            <div
              style={{
                width: result?.pixels,
                marginLeft: calculateMarginLeft(week, reservation?.startDate),
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                borderRadius: '12px',
                border: '4px solid transparent', // Bordure de 4px
                height: 35
              }}
              className={`reservation ${toolsColors[reservation.company]}`}
            >{reservation.companyLogo && <img
              src={reservation.companyLogo}
              alt="Logo"
              style={{
                width: '20px',
                height: '20px',
                marginRight: '5px',
                verticalAlign: 'middle',
              }}
            />}
              <b style={{ textShadow: result?.pixels < columnWidth ? '1px 1px 2px black' : 'none' }}>{reservation.clientName} </b>
            </div>
          </OverlayTrigger>
        </div>
      );
    }
    const unavailable = unavailableDates.find(unav => unav.villaId === villa.id && dateString >= unav.startDate && dateString <= unav.endDate);

    if (unavailable) {
      const result = calculatePixelsBetweenDates(unavailable.startDate, unavailable.endDate)

      return <div
        onClick={() => handleCellToggleAvailability(villa.id, dateString)}
        style={{
          ...cellStyle,
          width: result?.pixels, // Étend la cellule sur plusieurs colonnes
          textAlign: 'center',
          lineHeight: '40px',
          marginLeft: getPlacement(week, unavailable.startDate),

        }}
        className={'unavailable'}
      >{unavailable && <span>{unavailable?.message}</span>}</div>
    }

    return (
      <div
        onClick={() => handleCellUnavailableClick(villa.id, week[0])}
        style={{
          ...cellStyle,
          textAlign: 'center',
          lineHeight: '40px',
        }}
      />
    );
  };

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const cellStyle = {
      ...style,
      lineHeight: '40px',
      border: '1px solid #ddd', // Bordure à chaque cellule
    };

    if (rowIndex === 0 && columnIndex === 0) {
      return (
        <div
          style={{
            ...cellStyle,
            width: columnWidthVilla,
            backgroundColor: '#f0f0f0',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: '40px',
          }}
        >
          Villas
        </div>
      );
    }

    if (rowIndex === 0) {
      return (
        <div
          id={dayjs(dates[columnIndex - 1]).format('DD/MM/YYYY')}
          style={{
            ...cellStyle,
            backgroundColor: dayjs(dates[columnIndex - 1]).isSame(dayjs(), 'day') ? '#003366' : isSelectedDate(dates[columnIndex - 1]) ? "#c7454560" : '#f0f0f0',
            color: dayjs(dates[columnIndex - 1]).isSame(dayjs(), 'day') || isSelectedDate(dates[columnIndex - 1]) ? '#ffffff' : '#5e6e82',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: '40px',
            border: 'none'
          }}
        >
          {dayjs(dates[columnIndex - 1]).format('DD/MM/YYYY')}
        </div>
      );
    }

    if (columnIndex === 0 && rowIndex > 0) {
      return (
        <div
          key={`${filteredVillas[rowIndex - 1].id}`}

          style={{
            ...cellStyle,
            backgroundColor: '#f7f7f7',
            fontWeight: 'bold',
            lineHeight: '40px',
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                <a
                  href={`/villa/edit/${filteredVillas[rowIndex - 1].id}`}
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "inherit",
                  }}
                >
                  {filteredVillas[rowIndex - 1]?.picture ? (

                    <img
                      src={filteredVillas[rowIndex - 1]?.picture}
                      alt={filteredVillas[rowIndex - 1]?.name}
                      className="w-5 h-5 mr-2"
                      style={{ marginRight: 10, width: 150, draggable: 'none' }}
                    />
                  ) : <p>Aucune image</p>}
                </a>
              </Tooltip>
            }
          >
            <a
              href={`/villa/edit/${filteredVillas[rowIndex - 1].id}`}
              target="_blank"
              style={{
                textDecoration: "none",
                cursor: "pointer",
                color: "inherit",
                paddingLeft:20
              }}
            >

              {filteredVillas[rowIndex - 1]?.name || ''}
            </a>

          </OverlayTrigger>

        </div>
      );
    }

    const villa = filteredVillas[rowIndex - 1];
    const date = dates[columnIndex - 1];
    const reservation = reservations.find(
      (res) =>
        res.villaId === villa.id &&
        dayjs(date).isBetween(dayjs(res.startDate), dayjs(res.endDate).subtract(1, 'day'), 'day', '[]')
    );

    if (reservation) {
      const startDate = dayjs(reservation.startDate);
      const endDate = dayjs(reservation.endDate);
      if (dayjs(date).isSame(startDate, 'day')) {
        const duration = endDate.diff(startDate, 'day');
        return (
          <div
            style={{
              ...cellStyle,
              // position: 'relative',
              zIndex: 1,
              width: duration * columnWidth, // Étend la cellule sur plusieurs colonnes
              whiteSpace: 'nowrap',
              fontSize: '12px',
              color: '#007bff',
              textAlign: 'center',
              cursor: 'pointer',
              padding: '1px',
            }}
            onClick={() => handleCellClick(reservation)} // Ouvrir la modal au clic
          >
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={{ position: 'fixed' }} id="nextTooltip">

                  <>
                    <p>{reservation.companyLogo && <img src={reservation.companyLogo} alt="Logo" style={{ width: '20px' }} />} Réservé via: {reservation.tool}</p>
                    <p><strong>Client:</strong> {reservation.clientName}</p>
                    <p>
                      <strong>Villa:</strong> {reservation?.villaName}
                    </p>
                    <p><strong>Dates:</strong> {dayjs(reservation.startDate).format('DD/MM/YYYY')} - {dayjs(reservation.endDate).format('DD/MM/YYYY')}</p>

                    <p><strong>Prix payé:</strong> {new Intl.NumberFormat('fr-FR').format(reservation?.total_pay)} €</p>

                  </>
                </Tooltip>
              }>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  borderRadius: '12px',
                  border: '4px solid transparent', // Bordure de 4px
                  height: 35
                }}
                id={reservation.id}
                className={`reservation ${toolsColors[reservation.company]}`}

              >{reservation.companyLogo && <img
                src={reservation.companyLogo}
                alt="Logo"
                style={{
                  width: '20px',
                  height: '20px',
                  marginRight: '5px',
                  verticalAlign: 'middle',
                }}
              />}

                <b style={{ textShadow: '1px 1px 2px black' }}>{reservation.clientName}</b>
              </div>
            </OverlayTrigger>



          </div>
        );
      } else {

        return <div style={{ ...cellStyle, border: 'none', cursor: 'pointer', borderRadius: 0 }} className={`reservation ${toolsColors[reservation.company]}-2`} onClick={() => handleCellClick(reservation)} />; // Les autres cellules pour cette réservation sont vides
      }
    }
    const dateString = formatDateT(date);
    const unavailable = unavailableDates.find(unav => unav.villaId === villa.id && dateString >= unav.startDate && dateString <= unav.endDate);

    if (unavailable) {
      return <div
        onClick={() => handleCellToggleAvailability(villa.id, dateString)}
        style={{
          ...cellStyle,
          textAlign: 'center',
          lineHeight: '40px',
        }}
        className={'unavailable'}
      >{unavailable && <span>{unavailable?.message}</span>}</div>
    }

    return (
      <div
        onClick={() => handleCellUnavailableClick(villa.id, date)}
        style={{
          ...cellStyle,
          textAlign: 'center',
          lineHeight: '40px',
        }}
      />
    );
  };
  const handleViewModeChange = (mode) => {
    toast.warning('Chargement...');
    if (mode === 'week') {
      window.location.reload();
    }
    setViewMode(mode);
  };
  const [loadView, setLoadView] = useState(false);

  useEffect(() => {
    // afficher un message de chargement au dessus de tout la vue
    setLoadView(true);
    setTimeout(() => {
      setLoadView(false)
    }, 3500);
  }, [viewMode]);


  const handleHeaderScroll = ({ scrollLeft, scrollTop }) => {
    if (headerRef.current) {
      headerRef.current.scrollTo({ scrollLeft });
    }
    if (villaRef.current) {
      villaRef.current.scrollTo({ scrollTop })
    }

  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'Europe/Paris' });
  };

  const generateRandomId = () => {
    return `unvail-${Math.random().toString(36).slice(2, 18)}`; 
  };

  const handleUnavailableSubmit = () => {
    let ud = unavailableDates;
    ud.push({
      ...unavailableDetails,
      startDate: dayjs(unavailableDetails.startDate).format('YYYY-MM-DD'),
      id_software : generateRandomId(),
      id: unavailableDates.length + 1
    });
    firebase.firestore().collection("dates").doc("unavailable").set({ dates: ud });
    setUnavailableDates(ud)
    setShowUnavailableModal(false);
  };

  const getVisibleDates = () => {
    if (viewMode === 'day') {
      return dates;
    } else if (viewMode === 'week') {
      const weeks = [];
      let currentWeek = [];
      for (let i = 0; i < dates.length; i++) {
        const date = new Date(dates[i]);
        currentWeek.push(dates[i]);
        if (date.getDay() === 6) {
          weeks.push(currentWeek);
          currentWeek = [];
        }
      }
      if (currentWeek.length > 0) {
        weeks.push(currentWeek);
      }
      return weeks;
    }
  };
  return (
    <div
      style={{
        height: '86vh',
        width: '93%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <h1>Calendrier des Réservations</h1>

      <Row className="row mb-4 ">
        <div className="col-auto">

          <button
            className={`px-4 py-2 mr-2 ${viewMode === 'day' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => handleViewModeChange('day')}
          >
            Vue Jour
          </button>
          <button
            className={`px-4 py-2 ${viewMode === 'week' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => handleViewModeChange('week')}
          >
            Vue Semaine
          </button>

        </div>
        <div className="col-auto">
          <select
            className="form-control"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="">Sélectionner un type</option>
            {config.typehome.map((type, index) => (
              <option key={index} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto">
          <input
            type="text"
            className="form-control"
            style={{ width: "300px" }}
            placeholder="Rechercher une villa..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        {viewMode !== "week" && (<>
          <div className="col-auto">
            <button
              className="btn btn-primary"
              onClick={() => {
                scrollToToday()
                setSelectedDate(new Date().toISOString().split("T")[0]);
              }}
            >
              Aujourd'hui
            </button>
          </div>
          <div className="col-auto">
            <input
              type="date"
              className="form-control"
              value={selectedDate}
              onChange={(e) => handleDateChange(e.target.value)}
            />
          </div>

        </>)}

      </Row>
      {/* <p class="card-text" style={{marginBottom:0}}>
        <span class="me-2"  >⚠️</span>
        Les fonctionnalités de <strong>drag and drop</strong> ont été désactivées.
      </p> */}
      {dates.length > 0 ? <>
        {viewMode === 'day' ? (<>
          <div style={{ position: 'relative', top: 40, backgroundColor: '#fff', zIndex: 3, paddingLeft: columnWidthVilla - columnWidth }}>
            <Grid
              ref={headerRef}
              columnCount={dates.length}
              columnWidth={columnWidth}
              height={rowHeight}
              rowCount={1}
              rowHeight={rowHeight}
              width={window.innerWidth}
              style={{ overflow: 'hidden' }}
              cellStyle={{ position: 'absolute' }}
            >
              {Cell}
            </Grid>
          </div>
          <div style={{ display: 'flex', zIndex: 2 }}>
            <Grid
              ref={villaRef}
              columnWidth={columnWidthVilla}
              height={gridHeight}
              columnCount={1}
              rowCount={filteredVillas.length + 1}
              rowHeight={rowHeight}
              width={window.innerWidth}
              style={{ overflow: 'hidden', width: columnWidthVilla }}
            >
              {({ columnIndex, rowIndex, style }) => (
                <Cell columnIndex={columnIndex} rowIndex={rowIndex} style={style} isFirstColumn={true} />
              )}
            </Grid>

            <div style={{ overflow: 'auto', flexGrow: 1, zIndex: 1 }}>
              <Grid
                ref={tableRef}
                columnCount={dates.length - 1} // Moins 1 car la première colonne est séparée
                columnWidth={columnWidth}
                height={gridHeight}
                rowCount={filteredVillas.length + 1}
                rowHeight={rowHeight}
                onScroll={handleHeaderScroll}
                overscanColumnCount={5}
                overscanRowCount={50}
                itemKey={itemKey}
                width={window.innerWidth * 0.9 - columnWidthVilla - 40} // Soustraction de la largeur de la première colonne
                cellStyle={{ position: 'absolute' }}
              >
                {({ columnIndex, rowIndex, style }) => (
                  <Cell columnIndex={columnIndex + 1} rowIndex={rowIndex} style={style} isFirstColumn={false} />
                )}
              </Grid>
            </div>
          </div>
        </>) : <>

          <div style={{ position: 'relative', top: 40, backgroundColor: '#fff', zIndex: 1, paddingLeft: columnWidthVilla - columnWidth }}>

            <Grid
              ref={headerRef}
              columnCount={getVisibleDates().length}
              columnWidth={columnWidth}
              height={rowHeight}
              rowCount={1}
              rowHeight={rowHeight}
              width={window.innerWidth * 0.9}
              style={{ overflow: 'hidden' }}
            >
              {CellWeek}

            </Grid>
          </div>
          <div style={{ display: 'flex' }}>
            <Grid
              // columnCount={dates.length}
              ref={villaRef}
              columnWidth={columnWidthVilla}
              height={gridHeight}
              columnCount={1}
              rowCount={filteredVillas.length + 1}
              rowHeight={rowHeight}
              width={window.innerWidth * 0.9}
              style={{ overflow: 'hidden', width: columnWidthVilla }}
            >
              {CellWeek}
            </Grid>

            <div style={{ overflow: 'auto', flexGrow: 1 }}>
              <Grid
                ref={tableRef}
                columnCount={getVisibleDates().length - 1} // Moins 1 car la première colonne est séparée
                columnWidth={columnWidth}
                height={gridHeight}
                rowCount={filteredVillas.length + 1}
                rowHeight={rowHeight}
                onScroll={handleHeaderScroll}
                itemKey={itemKey}
                overscanColumnCount={5}
                overscanRowCount={50}
                width={window.innerWidth * 0.9 - columnWidthVilla} // Soustraction de la largeur de la première colonne
              >
                {({ columnIndex, rowIndex, style }) => (
                  <CellWeek columnIndex={columnIndex + 1} rowIndex={rowIndex} style={style} isFirstColumn={false} />
                )}
              </Grid>
            </div>
          </div>
        </>

        }
      </> : <p>Chargement..</p>}

      {loadView && (
        // créer une vue qui prend toute la page
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Chargement...</span>
          </div>
        </div>
      )}

      {/* Modal pour les détails de la réservation */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Détails de la Réservation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reservationDetails && (
            <>
              <p>{reservationDetails.companyLogo && <img src={reservationDetails.companyLogo} alt="Logo" style={{ width: '20px' }} />} Réservé via: {reservationDetails.tool}</p>
              <p><strong>Client:</strong> {reservationDetails.clientName}
                <a href={`/crm/edit/${reservationDetails?.clientId}`} target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-eye" style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
                </a></p>
              <p>
                <strong>Villa:</strong> {reservationDetails?.villaName}
                <a href={`/v/${reservationDetails?.villaId}`} target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-eye" style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
                </a>
              </p>
              <p><strong>Dates:</strong> {dayjs(reservationDetails.startDate).format('DD/MM/YYYY')} - {dayjs(reservationDetails.endDate).format('DD/MM/YYYY')}</p>

              <p><strong>Prix payé:</strong> {new Intl.NumberFormat('fr-FR').format(reservationDetails?.total_pay)} €</p>

            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => openLinkInNewTab(`/booking/edit/${reservationDetails.id}`)}>
            Ouvrir la réservation
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour la gestion des dates d'indisponibilité */}
      <Modal show={showUnavailableModal} onHide={() => setShowUnavailableModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Non-disponibilité de la Villa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formTitle">
              <Form.Label>Titre de la Non-Disponibilité</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex. Entretien, Maintenance"
                value={unavailableDetails.message}
                onChange={(e) => setUnavailableDetails({ ...unavailableDetails, message: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="formEndDate">
              <Form.Label>Date de Fin</Form.Label>
              <Form.Control
                type="date"
                value={unavailableDetails.endDate}
                onChange={(e) => setUnavailableDetails({ ...unavailableDetails, endDate: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUnavailableModal(false)}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleUnavailableSubmit}>
            Confirmer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Calendar;